import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Seo } from "@/components/common/Seo";
import { PAGES, IMAGES, SEO } from "@/content/site";
import { Logo } from "@/components/Logo";

export default function OurBrands() {
  const p = PAGES.ourBrands;
  return (
    <div data-testid="page-our-brands">
      <Seo title={SEO.ourBrands.t} description={SEO.ourBrands.d} path="/our-brands" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.freight} />
      <section className="container-x py-16 lg:py-24">
        {/* Featured brand: Azeka Health */}
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-azeka-navy">
            <img src={IMAGES.botanical} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" />
            <div className="absolute inset-0 bg-gradient-to-r from-azeka-navy via-azeka-navy/95 to-azeka-navy/70" />
            <div className="relative grid gap-10 p-8 sm:p-12 lg:grid-cols-12 lg:items-center lg:p-16">
              <div className="lg:col-span-7">
                <div className="w-fit rounded-2xl bg-white/95 px-6 py-5">
                  <Logo variant="health" className="h-14 w-auto sm:h-16" />
                </div>
                <h2 className="mt-8 text-3xl sm:text-4xl font-semibold text-white">Azeka Health</h2>
                <p className="mt-1 text-sm font-semibold uppercase tracking-[0.2em] text-azeka-teal2">
                  Pure Wellbeing
                </p>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-300">
                  The dedicated home of Azeka-owned or controlled health and wellbeing brands.
                </p>
                <div className="mt-8 flex flex-wrap items-center gap-5">
                  <span className="inline-flex items-center rounded-full bg-azeka-amber/95 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-azeka-navy">
                    Portfolio Coming Soon
                  </span>
                  <a
                    href="https://azekahealth.com"
                    data-testid="brands-health-link"
                    className="inline-flex items-center gap-2 rounded-full bg-azeka-teal px-6 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-azeka-teal2 hover:-translate-y-0.5 active:scale-95"
                  >
                    Visit Azeka Health <ArrowUpRight className="h-4 w-4" />
                  </a>
                </div>
              </div>
              <div className="lg:col-span-5">
                <div className="relative overflow-hidden rounded-2xl border border-white/10">
                  <img src={IMAGES.spaLeaf} alt="Azeka Health — Pure Wellbeing" className="h-[300px] w-full object-cover" />
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Context note */}
        <Reveal delay={0.1}>
          <p className="mx-auto mt-12 max-w-3xl text-center text-base leading-relaxed text-ink-body">
            AZEKA GLOBAL TRADE FZCO develops and commercialises selected health, wellbeing and related
            brands through qualified manufacturing and market partners. Further brands may be introduced
            as the portfolio grows.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
